<template>
  <div>
    <router-view :truncated="!hasSubscription"></router-view>
    <premium-modal v-if="showMessage" />
    <b-loading :is-full-page="true" :active="subscriptionIsLoading"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PremiumModal from '@/components/Premium/PremiumModal.vue'

export default {
  name: 'Premium',
  components: {
    PremiumModal
  },
  computed: {
    ...mapGetters([
      'hasSubscription',
      'subscriptionIsLoading',
    ]),
    isPremiumRoute() {
      return this.$route.name !== 'premium'
    },
    showMessage() {
      return !this.subscriptionIsLoading && (!this.isPremiumRoute || !this.hasSubscription)
    }
  }
};
</script>

<style scoped lang="scss">
.needs-subscription {
  margin-top: 20px;
}

.notification {
  display: flex;
  flex-direction: column;

  .button {
    align-self: flex-end;
    margin-top: 10px;

      @media only screen and (max-device-width : 768px) {
        align-self: center;
      }
  }
}
</style>
